import { ColumnDef } from '@tanstack/react-table';
// @ts-ignore
import { Rating, Typography } from '@growdash/design-system/atoms';
import GrowintelImage from '@growdash/growintel/components/atoms/growintel-image';
import RestaurantLink from '@growdash/growintel/components/atoms/restaurant-link';
import { Branch } from '@growdash/growintel/generated';
import useCurrency from '@growdash/growintel/hooks/useCurrency';
// ----------------------------------------------------------------------

const columns: ColumnDef<Branch>[] = [
  {
    accessorKey: 'branch_image',
    header: 'Logo',
    cell: ({ row }) => (
      <RestaurantLink id={row.original.branch_id}>
        <div className="w-6 h-6 overflow-hidden rounded-full">
          <GrowintelImage
            className="w-full h-full"
            src={row.original.branch_image ?? ''}
          />
        </div>
      </RestaurantLink>
    ),
  },
  {
    accessorKey: 'branch_name',
    header: 'Name',
    cell: ({ row }) => (
      <RestaurantLink id={row.original.branch_id}>
        {row.original.branch_name}
      </RestaurantLink>
    ),
  },
  {
    accessorKey: 'cuisines',
    header: 'Cuisines',
  },
  {
    accessorKey: 'city',
    header: 'City',
  },
  {
    accessorKey: 'avg_price',
    header: 'Avg Price',
    cell: ({ row }) => {
      const currency = useCurrency() || '';
      const value = row.original.avg_price;
      return value && value > 0 ? `${value.toFixed(0)} ${currency}` : '-';
    },
  },
  {
    accessorKey: 'median_price',
    header: 'Median Price',
    cell: ({ row }) => {
      const currency = useCurrency() || '';
      const value = row.original.median_price;
      return value && value > 0 ? `${value} ${currency}` : '-';
    },
  },
  {
    accessorKey: 'delivery_time',
    header: 'Delivery Time',
    cell: ({ row }) => {
      const value = row.original.delivery_time;
      return value && value > 0 ? `${value.toFixed(0)} min` : '-';
    },
  },
  {
    accessorKey: 'total_rating_count',
    header: 'Rating / Total',
    cell: ({ row }) => {
      return (
        <div className="flex items-center gap-1">
          <Rating
            size="small"
            value={Math.max(0, row.original.rating_score ?? 0)}
            readOnly
          />
          <Typography>{row.original.rating_count}</Typography>
        </div>
      );
    },
  },
];

export default columns;
